export const EDITED = 'edited';
export const ORIGINAL = 'original';

export const VIDEO_VERSION = {
    [ORIGINAL]: 'my_video.state.original',
    [EDITED]: 'my_video.state.edited',
}